module.exports = __webpack_public_path__ + "img/actinum.15479672.jpg";